import {DataGrid, esES} from "@mui/x-data-grid";
import React, {Fragment, useState} from "react";
import {Avatar, Stack, Tooltip, Typography} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import {SolicitationClient, SolicitationClientFields} from "src/types/solicitation/solicitationData";
import {MaritalStates} from "../../../../../types/generalData";
import {ClientRelationshipViewFields} from "../../../../../types/client/clientData";
import {DeleteIconButton, EditIconButton} from "../../../../../components/buttons/Buttons";
import {dateFormatter} from "../../../../../utils/formatters";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import {stringFormatter} from "../../../../../utils/formatters/stringFormatter";

interface SuretiesDataDetailTableProps {
    sureties?: SolicitationClient[],
    onEdit?: (solicitationClient: SolicitationClient) => void,
    onDelete?: (solicitationClientId: number) => void
}


const SuretiesDataDetailTable = ({sureties, onEdit, onDelete}: SuretiesDataDetailTableProps) => {
    const [pageSize, setPageSize] = useState<number>(5)
    
    const cols = [
        {
            flex: 0.175,
            field: 'descClienteTipo',
            headerName: 'Fiador/a',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={4} alignItems={'center'}>
                    {params.row[ClientRelationshipViewFields.ClientTypeDesc] === 'Fisica' ? <Avatar><PersonIcon /></Avatar> : <Avatar><BusinessIcon /></Avatar>}
                    <Stack spacing={1}>
                        <Typography fontWeight={600} fontSize={14}>{params.row[ClientRelationshipViewFields.BusinessName]}</Typography>
                        <Typography fontSize={12} color={'grey'} fontWeight={500}>
                            {numberFormatter.toCuitString(params.row[ClientRelationshipViewFields.CUIT])}
                        </Typography>
                    </Stack>
                </Stack>
            )
        },
        {
            flex: 0.08,
            minWidth: 90,
            field: SolicitationClientFields.BirthDate,
            headerName: 'Fecha de Nacimiento',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{dateFormatter.toShortDate(params.row[SolicitationClientFields.BirthDate])}</Typography>
            )
        },
        {
            flex: 0.06,
            minWidth: 110,
            field: SolicitationClientFields.MaritalStatusDesc,
            headerName: 'Estado Civil',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{params.row[SolicitationClientFields.MaritalStatusDesc]}</Typography>
            )
        },
        {
            flex: 0.14,
            field: SolicitationClientFields.FianceName,
            minWidth: 125,
            headerName: 'Razón Social/Nombre (Conyuge)',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{(params.row[SolicitationClientFields.MaritalStatusCode] !== MaritalStates.Casado &&
                    params.row[SolicitationClientFields.MaritalStatusCode] !== MaritalStates.Convivientes) ? '-' :
                    params.row[SolicitationClientFields.FianceName]}</Typography>
            )
        },
        {
            flex: 0.14,
            field: SolicitationClientFields.Address,
            minWidth: 125,
            headerName: 'Dirección',
            renderCell: (params: any) => (
                <div>
                    <Tooltip title={params.row[SolicitationClientFields.Address]}>
                        <Typography fontSize={13}>{stringFormatter.cutIfHaveMoreThan(params.row[SolicitationClientFields.Address], 55)}</Typography>
                    </Tooltip>
                </div>
            )
        },
        {
            flex: 0.055,
            minWidth: 80,
            field: 'acciones',
            headerName: 'Acciones',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                    <EditIconButton tooltipTitle={'Editar'} onClick={() => onEdit && onEdit(params.row as SolicitationClient)} />
                    <DeleteIconButton onClick={() => onDelete && onDelete(params.row[EntityWithIdFields.Id])} tooltipTitle={'Eliminar'} />
                </Stack>
            )
        }
    ]
    
    const colsView = [
        {
            flex: 0.175,
            field: 'descClienteTipo',
            headerName: 'Fiador/a',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={4} alignItems={'center'}>
                    {params.row[ClientRelationshipViewFields.ClientTypeDesc] === 'Fisica' ? <Avatar><PersonIcon /></Avatar> : <Avatar><BusinessIcon /></Avatar>}
                    <Stack spacing={1}>
                        <Typography fontWeight={600} fontSize={14}>{params.row[ClientRelationshipViewFields.BusinessName]}</Typography>
                        <Typography fontSize={12} color={'grey'} fontWeight={500}>
                            {numberFormatter.toCuitString(params.row[ClientRelationshipViewFields.CUIT])}
                        </Typography>
                    </Stack>
                </Stack>
            )
        },
        {
            flex: 0.08,
            minWidth: 90,
            field: SolicitationClientFields.BirthDate,
            headerName: 'Fecha de Nacimiento',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{dateFormatter.toShortDate(params.row[SolicitationClientFields.BirthDate])}</Typography>
            )
        },
        {
            flex: 0.06,
            minWidth: 110,
            field: SolicitationClientFields.MaritalStatusDesc,
            headerName: 'Estado Civil',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{params.row[SolicitationClientFields.MaritalStatusDesc]}</Typography>
            )
        },
        {
            flex: 0.14,
            field: SolicitationClientFields.FianceName,
            minWidth: 125,
            headerName: 'Razón Social/Nombre (Conyuge)',
            renderCell: (params: any) => (
                <Typography fontSize={13}>{(params.row[SolicitationClientFields.MaritalStatusCode] !== MaritalStates.Casado &&
                    params.row[SolicitationClientFields.MaritalStatusCode] !== MaritalStates.Convivientes) ? '-' :
                    params.row[SolicitationClientFields.FianceName]}</Typography>
            )
        },
        {
            flex: 0.14,
            field: SolicitationClientFields.Address,
            minWidth: 125,
            headerName: 'Dirección',
            renderCell: (params: any) => (
                <div>
                    <Tooltip title={params.row[SolicitationClientFields.Address]}>
                        <Typography fontSize={13}>{stringFormatter.cutIfHaveMoreThan(params.row[SolicitationClientFields.Address], 55)}</Typography>
                    </Tooltip>
                </div>
            )
        }
    ]
    
    return (
        <Fragment>
        {
            sureties &&
            <DataGrid columns={(onEdit && onDelete) ? cols : colsView}
                      rows={sureties}
                      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                      autoHeight
                      rowsPerPageOptions={[5, 10, 25]}
                      pageSize={pageSize}
                      onPageSizeChange={newPageSize => setPageSize(newPageSize)}
            />
        }
        </Fragment>
    )
}


export default SuretiesDataDetailTable